// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const AnnotateOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M21 18l-3-3v2H5v2h13v2l3-3zM9.5 11.8h5l.9 2.2h2.1L12.75 3h-1.5L6.5 14h2.1l.9-2.2zM12 4.98L13.87 10h-3.74L12 4.98z","fill":"currentColor"}}]},"name":"annotate","theme":"outlined"};

const AnnotateOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={AnnotateOutlinedSvg} />;
  AnnotateOutlined.displayName = 'AnnotateOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(AnnotateOutlined);
